import React from 'react';
import PropTypes from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import { sendBigQueryEvents, sendMixpanelEvents } from '../biEvents';
import {
    selectEventSource,
    selectPageName,
    selectRecipientInfo,
    selectRelatedGigId,
    selectSubCategoryId,
    useStaticContext
} from './static';

const ReportContext = React.createContext();

export const ReportContextProvider = ({ children }) => {
    const { userId, pageCtxId, organizationId, userGuid, queryParameters = {} } = getContext();
    const { ref_ctx_id: refCtxId } = queryParameters;
    const context = useStaticContext();
    const recipientInfo = selectRecipientInfo(context);
    const pageName = selectPageName(context);
    const eventSource = selectEventSource(context);
    const gigId = selectRelatedGigId(context);
    const subCategoryId = selectSubCategoryId(context);
    const enrichment = {
        ...recipientInfo,
        userId,
        pageCtxId,
        userGuid,
        gigId,
        subCategoryId,
        pageName,
        eventSource,
        refCtxId,
        organizationId
    };

    const sendBiEvent = React.useCallback(
        ({ type, params }) => {
            sendBigQueryEvents({
                type,
                params: {
                    ...enrichment,
                    ...params
                }
            });
        }, [enrichment]
    );

    const sendMixpanelEvent = React.useCallback(
        ({ type, params }) => {
            sendMixpanelEvents({
                type,
                params: {
                    ...enrichment,
                    ...params
                }
            });
        }, [enrichment]
    );

    const reportContext = {
        sendMixpanelEvent,
        sendBiEvent
    };

    return (
        <ReportContext.Provider value={reportContext}>
            {children}
        </ReportContext.Provider>
    );
};

ReportContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export const useReporting = () => React.useContext(ReportContext);
